<template>
    <div class="createCandidate">
        <v-dialog ref="dialog" v-model="dialog" scrollable max-width="1200px" :fullscreen="$vuetify.breakpoint.xsOnly"
            transition="dialog-bottom-transition">
            <v-card :class="$vuetify.breakpoint.xsOnly ? '' : 'rounded-xl overflow-hidden'">
                <v-card-title class="teal darken-4 py-4 d-flex justify-space-between align-center white--text"
                    style="position: sticky; top: 0; z-index: 10;">
                    <span class="text-h6 font-weight-bold mb-0 white--text">
                        {{ isEdit ? 'CHI TIẾT HỒ SƠ ỨNG VIÊN' : 'TẠO MỚI HỒ SƠ ỨNG VIÊN' }}
                    </span>
                    <v-btn icon dark @click="dialog = false" class="ma-0">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-4 pa-sm-6" :style="$vuetify.breakpoint.xsOnly ? '' : 'max-height: 80vh;'">
                    <v-form class="mt-3" v-model="valid" ref="form" @submit.prevent="save" id="form">
                        <v-row>
                            <!-- Main Info Panel -->
                            <v-col cols="12" md="8">
                                <v-row dense>
                                    <!-- Avatar col -->
                                    <v-col cols="12" sm="4" class="mb-4 mb-sm-0 d-flex">
                                        <v-card outlined
                                            class="pa-4 text-center d-flex flex-column align-center justify-center rounded-lg fill-height"
                                            style="background-color: #fcfcfc; border-color: #e0e0e0 !important; width: 100%;">
                                            <div style="position: relative;" class="mb-3">
                                                <v-avatar class="elevation-2" size="120"
                                                    style="border: 1px solid #e0e0e0 !important;">
                                                    <v-img v-if="form.avatarUrl" :src="form.avatarUrl"
                                                        class="fill-height"></v-img>
                                                    <v-icon v-else size="60" color="teal darken-3">mdi-account</v-icon>
                                                </v-avatar>
                                            </div>
                                            <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
                                                style="line-height: 1.2;">
                                                {{ form.name || 'Họ tên ứng viên' }}
                                            </div>
                                            <div class="text-caption grey--text text--darken-1 mb-3">
                                                {{(jobs.find(j => j.code === form.jobCode) || {}).name || 'Vị trí ứng tuyển'}}
                                            </div>
                                            <v-chip v-if="form.code" color="teal lighten-5" text-color="teal darken-4"
                                                small class="font-weight-bold">
                                                Mã: {{ form.code }}
                                            </v-chip>
                                        </v-card>
                                    </v-col>

                                    <!-- Basic Fields -->
                                    <v-col cols="12" sm="8" class="d-flex flex-column justify-space-between">
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-text-field label="Tên ứng viên" outlined dense v-model="form.name"
                                                    hide-details="auto" class="mb-2"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-select label="Giới tính" outlined dense v-model="form.gender"
                                                    :items='[{ text: "Nam", value: true }, { text: "Nữ", value: false }]'
                                                    hide-details="auto" class="mb-2"></v-select>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field type="date" outlined dense v-model="form.birthDay"
                                                    label="Sinh nhật" hide-details="auto" class="mb-2"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-autocomplete label="Công việc ứng tuyển" outlined dense
                                                    v-model="form.jobCode" hide-details="auto" :items="jobs"
                                                    item-text="name" item-value="code" class="mb-2"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="Nơi làm việc mong muốn 1" outlined dense
                                                    hide-details="auto" v-model="form.city1Code" item-text="name"
                                                    item-value="code" :items="cities" class="mb-2"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="Quận (huyện) 1" outlined dense
                                                    hide-details="auto" v-model="form.jobDistrict1Code" item-text="name"
                                                    item-value="code" :items="jobDistrict1s"
                                                    class="mb-2"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="Nơi làm việc mong muốn 2" outlined dense
                                                    hide-details="auto" v-model="form.city2Code" item-text="name"
                                                    item-value="code" :items="cities" class="mb-2"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="Quận (huyện) 2" outlined dense
                                                    hide-details="auto" v-model="form.jobDistrict2Code" item-text="name"
                                                    item-value="code" :items="jobDistrict2s"
                                                    class="mb-2"></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <!-- Section: THÔNG TIN HỒ SƠ -->
                                    <v-col cols="12" class="mt-4 mb-2">
                                        <div class="d-flex align-center">
                                            <v-icon color="teal darken-4" class="mr-2"
                                                small>mdi-card-account-details-outline</v-icon>
                                            <span
                                                class="font-weight-bold text-subtitle-2 teal--text text--darken-4 uppercase-title">THÔNG
                                                TIN CHI TIẾT HỒ SƠ</span>
                                            <v-divider class="ml-3"></v-divider>
                                        </div>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-tabs color="teal darken-4" :vertical="!$vuetify.breakpoint.xsOnly"
                                            show-arrows class="border rounded-xl pa-2 scrollable-tab-items">
                                            <v-tab class="justify-start"><v-icon left small>mdi-phone-outline</v-icon>
                                                Thông tin cơ bản</v-tab>
                                            <v-tab class="justify-start"><v-icon left
                                                    small>mdi-account-details-outline</v-icon> Thông tin cá nhân</v-tab>
                                            <v-tab class="justify-start"><v-icon left
                                                    small>mdi-map-marker-outline</v-icon> Địa chỉ thường trú</v-tab>
                                            <v-tab class="justify-start"><v-icon left small>mdi-school-outline</v-icon>
                                                Học vấn</v-tab>
                                            <v-tab class="justify-start"><v-icon left
                                                    small>mdi-certificate-outline</v-icon> Chứng chỉ hành nghề</v-tab>
                                            <v-tab class="justify-start"><v-icon left
                                                    small>mdi-briefcase-outline</v-icon> Kinh nghiệm làm việc</v-tab>
                                            <v-tab class="justify-start"><v-icon left small>mdi-paperclip</v-icon> File
                                                đính kèm</v-tab>

                                            <!-- Tab 1: Thong tin co ban -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Thông tin liên hệ</div>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-text-field outlined dense
                                                            append-outer-icon="mdi-clipboard-file"
                                                            @click:append-outer="copyText('phoneInput')"
                                                            ref="phoneInput" label="Số điện thoại" v-model="form.phone"
                                                            :rules="[
                                                                v => !!v || 'Vui lòng nhập SDT', v => (v || '').length <= 15 || 'SDT quá dài',
                                                                v => (v || '').length > 9 || 'SDT quá ngắn',
                                                                v => !/\D/.test(v) || 'SDT không đúng']"
                                                            hide-details="auto" class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-text-field outlined dense
                                                            append-outer-icon="mdi-clipboard-file"
                                                            @click:append-outer="copyText('emailInput')"
                                                            ref="emailInput" label="Email" v-model="form.mail"
                                                            hide-details="auto" class="mb-3"
                                                            :rules="[
                                                                v => !!v || 'Vui lòng nhập Email', v => (v || '').length <= 50 || 'Email quá dài',
                                                                v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email không đúng']"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="mt-2">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Nguồn tuyển dụng</div>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Nguồn tuyển dụng"
                                                            v-model="form.recruitChannel" :items="recruitChannels"
                                                            hide-details="auto" class="mb-3"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Số năm kinh nghiệm"
                                                            v-model="form.yearExperience" :items="yearExperiences"
                                                            hide-details="auto" class="mb-3"></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                            </v-tab-item>

                                            <!-- Tab 2: Thong tin chi tiet -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Ngoại hình</div>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field outlined dense label="Chiều cao (cm)" suffix="cm"
                                                            v-model="form.height" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field outlined dense label="Cân nặng (kg)" suffix="kg"
                                                            v-model="form.weight" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="mt-2">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Thông tin cá nhân khác</div>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-select outlined dense label="Quốc tịch"
                                                            v-model="form.originCode" :items="origins" item-text="name"
                                                            hide-details="auto" class="mb-3"
                                                            item-value="code"></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-select outlined dense label="Dân tộc"
                                                            v-model="form.ethnicityCode" :items="ethnicities"
                                                            item-text="name" hide-details="auto" class="mb-3"
                                                            item-value="code"></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-select outlined dense label="Tôn giáo"
                                                            v-model="form.religionCode" :items="religions"
                                                            item-text="name" hide-details="auto" class="mb-3"
                                                            item-value="code"></v-select>
                                                    </v-col>

                                                    <v-col cols="12" class="mt-2">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Giấy tờ định danh</div>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field outlined dense label="Số CMND/CCCD"
                                                            v-model="form.idNumber" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field outlined dense type="date" label="Ngày cấp"
                                                            v-model="form.idDate" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-text-field outlined dense label="Nơi cấp"
                                                            v-model="form.idPlace" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="mt-2">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Thông tin Thuế & BHXH</div>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field outlined dense label="Mã số thuế"
                                                            v-model="form.taxNumber" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field outlined dense label="Số sổ BHXH"
                                                            v-model="form.insuranceNumber" hide-details="auto"
                                                            class="mb-3"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-tab-item>

                                            <!-- Tab 3: Dia chi -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <v-tabs v-model="addressTab" color="teal darken-4"
                                                    background-color="transparent" dense class="mb-4">
                                                    <v-tab>Địa chỉ mới</v-tab>
                                                    <v-tab>Địa chỉ cũ</v-tab>
                                                </v-tabs>

                                                <v-tabs-items v-model="addressTab">
                                                    <!-- Tab Địa chỉ mới -->
                                                    <v-tab-item>
                                                        <v-container class="pa-0">
                                                            <v-row dense>
                                                                <v-col cols="12">
                                                                    <div
                                                                        class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                                        Địa chỉ thường trú (Mới)</div>
                                                                </v-col>
                                                                <v-col cols="12">
                                                                    <v-autocomplete outlined dense
                                                                        label="Tỉnh / Thành phố"
                                                                        v-model="form.newCityId"
                                                                        @change="fetchNewWard(form.newCityId)"
                                                                        :items="newCities" item-text="name"
                                                                        item-value="id" hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12">
                                                                    <v-autocomplete outlined dense label="Phường / Xã"
                                                                        v-model="form.newWardId" :items="newWards"
                                                                        item-text="name" item-value="id"
                                                                        hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12">
                                                                    <v-text-field outlined dense
                                                                        label="Địa chỉ chi tiết" v-model="form.address"
                                                                        hide-details="auto" class="mb-3"></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-tab-item>

                                                    <!-- Tab Địa chỉ cũ -->
                                                    <v-tab-item>
                                                        <v-container class="pa-0">
                                                            <v-row dense>
                                                                <v-col cols="12">
                                                                    <div
                                                                        class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                                        Địa chỉ thường trú (Cũ)</div>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-autocomplete outlined dense label="Thành phố"
                                                                        v-model="form.oldCityCode" :items="cities"
                                                                        item-text="name" item-value="code"
                                                                        hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-autocomplete outlined dense label="Quận / Huyện"
                                                                        v-model="form.oldDistrictCode"
                                                                        :items="districts" item-text="name"
                                                                        item-value="code" hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-autocomplete outlined dense label="Phường / Xã"
                                                                        v-model="form.oldWardCode" :items="wards"
                                                                        item-text="name" item-value="code"
                                                                        hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12">
                                                                    <v-text-field outlined dense
                                                                        label="Địa chỉ chi tiết"
                                                                        v-model="form.oldAddress" hide-details="auto"
                                                                        class="mb-3"></v-text-field>
                                                                </v-col>

                                                                <v-col cols="12" class="mt-3">
                                                                    <div
                                                                        class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                                        Địa chỉ tạm trú (Cũ)</div>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-autocomplete outlined dense label="Thành phố"
                                                                        v-model="form.oldDCityCode" :items="cities"
                                                                        item-text="name" item-value="code"
                                                                        hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-autocomplete outlined dense label="Quận / Huyện"
                                                                        v-model="form.oldDDistrictCode"
                                                                        :items="dDistricts" item-text="name"
                                                                        item-value="code" hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12" sm="4">
                                                                    <v-autocomplete outlined dense label="Phường / Xã"
                                                                        v-model="form.oldDWardCode" :items="dWards"
                                                                        item-text="name" item-value="code"
                                                                        hide-details="auto"
                                                                        class="mb-3"></v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="12">
                                                                    <v-text-field outlined dense
                                                                        label="Địa chỉ chi tiết"
                                                                        v-model="form.oldDAddress" hide-details="auto"
                                                                        class="mb-3"></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                            </v-tab-item>

                                            <!-- Tab 4: Hoc van -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <v-row dense>
                                                    <!-- Section: Bằng cấp 1 -->
                                                    <v-col cols="12" class="mb-2">
                                                        <div class="d-flex align-center">
                                                            <v-icon color="teal darken-4" class="mr-2" small>mdi-numeric-1-circle</v-icon>
                                                            <span class="font-weight-bold text-subtitle-2 teal--text text--darken-4 uppercase-title">BẰNG CẤP 1</span>
                                                            <v-divider class="ml-3"></v-divider>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Trình độ học vấn 1"
                                                            v-model="form.educationLevelCode" :items="educationLevels"
                                                            item-text="name" item-value="code" hide-details="auto"
                                                            class="mb-3" clearable></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Chuyên ngành 1"
                                                            v-model="form.educationMajorCode" :items="educationMajors"
                                                            item-text="name" item-value="code" hide-details="auto"
                                                            class="mb-3" clearable></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Trường đào tạo 1"
                                                            v-model="form.universityCode" :items="universities"
                                                            item-text="name" item-value="code" hide-details="auto"
                                                            class="mb-3" clearable></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select outlined dense label="Trạng thái tốt nghiệp 1"
                                                            v-model="form.graduateStatus" :items="educationStatuses"
                                                            item-text="text" item-value="value" hide-details="auto"
                                                            class="mb-3" clearable></v-select>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select outlined dense label="Xếp loại 1"
                                                            v-model="form.eduRating" :items="['Xuất sắc', 'Giỏi', 'Khá', 'Trung Bình']"
                                                            hide-details="auto" class="mb-3" clearable></v-select>
                                                    </v-col>
                                                    <v-col cols="12" class="mb-4">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Bằng cấp 1 / Chứng chỉ đính kèm</div>
                                                        <div v-if="!form.eduFileUrl"
                                                            class="text-caption grey--text pl-2">
                                                            Chưa tải lên bằng cấp
                                                        </div>
                                                        <div v-else>
                                                            <v-card outlined
                                                                class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                                style="max-width: 500px; background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                                <div class="d-flex align-center text-truncate mr-2">
                                                                    <v-icon color="teal darken-4" class="mr-2">
                                                                        {{ isImageFile(form.eduFileUrl) ?
                                                                            'mdi-image-outline' :
                                                                            'mdi-file-document-outline' }}
                                                                    </v-icon>
                                                                    <span
                                                                        class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">File
                                                                        bằng cấp 1</span>
                                                                </div>
                                                                <v-btn color="teal darken-4" dark small
                                                                    class="rounded-lg font-weight-bold"
                                                                    :href="form.eduFileUrl" target="_blank">
                                                                    <v-icon small left>mdi-eye</v-icon> Xem / Tải xuống
                                                                </v-btn>
                                                            </v-card>
                                                        </div>
                                                    </v-col>

                                                    <!-- Section: Bằng cấp 2 -->
                                                    <v-col cols="12" class="mt-4 mb-2">
                                                        <div class="d-flex align-center">
                                                            <v-icon color="teal darken-4" class="mr-2" small>mdi-numeric-2-circle</v-icon>
                                                            <span class="font-weight-bold text-subtitle-2 teal--text text--darken-4 uppercase-title">BẰNG CẤP 2</span>
                                                            <v-divider class="ml-3"></v-divider>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Trình độ học vấn 2"
                                                            v-model="form.educationLevel2Code" :items="educationLevels"
                                                            item-text="name" item-value="code" hide-details="auto"
                                                            class="mb-3" clearable></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Chuyên ngành 2"
                                                            v-model="form.educationMajor2Code" :items="educationMajors"
                                                            item-text="name" item-value="code" hide-details="auto"
                                                            class="mb-3" clearable></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-autocomplete outlined dense label="Trường đào tạo 2"
                                                            v-model="form.university2Code" :items="universities"
                                                            item-text="name" item-value="code" hide-details="auto"
                                                            class="mb-3" clearable></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select outlined dense label="Trạng thái tốt nghiệp 2"
                                                            v-model="form.graduateStatus2" :items="educationStatuses"
                                                            item-text="text" item-value="value" hide-details="auto"
                                                            class="mb-3" clearable></v-select>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select outlined dense label="Xếp loại 2"
                                                            v-model="form.eduRating2" :items="['Xuất sắc', 'Giỏi', 'Khá', 'Trung Bình']"
                                                            hide-details="auto" class="mb-3" clearable></v-select>
                                                    </v-col>
                                                    <v-col cols="12" class="mb-4">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Bằng cấp 2 đính kèm</div>
                                                        <div v-if="!form.eduFile2Url"
                                                            class="text-caption grey--text pl-2">
                                                            Chưa tải lên bằng cấp 2
                                                        </div>
                                                        <div v-else>
                                                            <v-card outlined
                                                                class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                                style="max-width: 500px; background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                                <div class="d-flex align-center text-truncate mr-2">
                                                                    <v-icon color="teal darken-4" class="mr-2">
                                                                        {{ isImageFile(form.eduFile2Url) ?
                                                                            'mdi-image-outline' :
                                                                            'mdi-file-document-outline' }}
                                                                    </v-icon>
                                                                    <span
                                                                        class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">File
                                                                        bằng cấp 2</span>
                                                                </div>
                                                                <v-btn color="teal darken-4" dark small
                                                                    class="rounded-lg font-weight-bold"
                                                                    :href="form.eduFile2Url" target="_blank">
                                                                    <v-icon small left>mdi-eye</v-icon> Xem / Tải xuống
                                                                </v-btn>
                                                            </v-card>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-tab-item>

                                            <!-- Tab: Chứng chỉ hành nghề dược -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <v-row dense>
                                                    <v-col cols="12" class="mb-2">
                                                        <div class="d-flex align-center">
                                                            <v-icon color="teal darken-4" class="mr-2" small>mdi-certificate</v-icon>
                                                            <span class="font-weight-bold text-subtitle-2 teal--text text--darken-4 uppercase-title">CHỨNG CHỈ HÀNH NGHỀ DƯỢC</span>
                                                            <v-divider class="ml-3"></v-divider>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select outlined dense label="Chứng chỉ hành nghề dược"
                                                            v-model="form.hasPharmaCert" :items="[{ text: 'Có', value: true }, { text: 'Không', value: false }]"
                                                            hide-details="auto" class="mb-3" clearable></v-select>
                                                    </v-col>
                                                    <v-col cols="12" class="mt-2" v-if="form.pharmaCertUrl">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Chứng chỉ đính kèm</div>
                                                        <v-card outlined
                                                            class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                            style="max-width: 500px; background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                            <div class="d-flex align-center text-truncate mr-2">
                                                                <v-icon color="teal darken-4" class="mr-2">
                                                                    {{ isImageFile(form.pharmaCertUrl) ?
                                                                        'mdi-image-outline' :
                                                                        'mdi-file-document-outline' }}
                                                                </v-icon>
                                                                <span
                                                                    class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">File chứng chỉ</span>
                                                            </div>
                                                            <v-btn color="teal darken-4" dark small
                                                                class="rounded-lg font-weight-bold"
                                                                :href="form.pharmaCertUrl" target="_blank">
                                                                <v-icon small left>mdi-eye</v-icon> Xem / Tải xuống
                                                            </v-btn>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-tab-item>

                                            <!-- Tab 5: Kinh nghiem lam viec -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <div v-if="form.yearExperience == 0"
                                                    class="text-center py-6 grey--text">
                                                    Chưa có kinh nghiệm làm việc
                                                </div>
                                                <v-card v-else outlined class="rounded-xl overflow-hidden">
                                                    <v-data-table :headers="expCompanyHeaders" :items="expCompanies"
                                                        class="elevation-0" hide-default-footer>
                                                        <template v-slot:[`item.from`]="{ item }">
                                                            {{ $formatter.formatDate(item.from) }}
                                                        </template>
                                                        <template v-slot:[`item.to`]="{ item }">
                                                            {{ $formatter.formatDate(item.to) }}
                                                        </template>
                                                    </v-data-table>
                                                </v-card>
                                            </v-tab-item>

                                            <!-- Tab 6: File dinh kem -->
                                            <v-tab-item class="pa-4 pa-sm-6">
                                                <v-row dense>
                                                    <!-- Giấy khám sức khỏe -->
                                                    <v-col cols="12" sm="6" class="mb-3">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Giấy khám sức khỏe</div>
                                                        <div v-if="!form.attachmentUrl"
                                                            class="text-caption red--text pl-2">
                                                            Không có giấy khám sức khỏe
                                                        </div>
                                                        <div v-else>
                                                            <!-- If it is an image: display exactly like CCCD -->
                                                            <v-card v-if="isImageFile(form.attachmentUrl)" outlined
                                                                class="rounded-lg overflow-hidden"
                                                                style="border-color: #e0e0e0 !important;">
                                                                <a :href="form.attachmentUrl" target="_blank">
                                                                    <v-img :src="form.attachmentUrl" max-height="300"
                                                                        contain
                                                                        class="grey lighten-4 cursor-pointer"></v-img>
                                                                </a>
                                                                <div
                                                                    class="pa-2 text-center grey lighten-5 border-t text-caption">
                                                                    <a :href="form.attachmentUrl" target="_blank"
                                                                        class="teal--text text--darken-4 font-weight-bold text-decoration-none">
                                                                        <v-icon x-small color="teal darken-4"
                                                                            class="mr-1">mdi-open-in-new</v-icon> Click
                                                                        để xem ảnh
                                                                        phóng to
                                                                    </a>
                                                                </div>
                                                            </v-card>

                                                            <!-- If it is NOT an image: show file icon and download button -->
                                                            <v-card v-else outlined
                                                                class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                                style="background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                                <div class="d-flex align-center text-truncate mr-2">
                                                                    <v-icon color="teal darken-4"
                                                                        class="mr-2">mdi-file-document-outline</v-icon>
                                                                    <span
                                                                        class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">Tài
                                                                        liệu khám sức khỏe</span>
                                                                </div>
                                                                <v-btn color="teal darken-4" dark small
                                                                    class="rounded-lg font-weight-bold"
                                                                    :href="form.attachmentUrl" target="_blank">
                                                                    <v-icon small left>mdi-download</v-icon> Tải xuống
                                                                </v-btn>
                                                            </v-card>
                                                        </div>
                                                    </v-col>

                                                    <!-- Bằng cấp / Chứng chỉ 1 -->
                                                    <v-col cols="12" sm="6" class="mb-3">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Bằng cấp / Chứng chỉ 1</div>
                                                        <div v-if="!form.eduFileUrl"
                                                            class="text-caption red--text pl-2">
                                                            Không có file bằng cấp 1
                                                        </div>
                                                        <div v-else>
                                                            <!-- If it is an image: display exactly like CCCD -->
                                                            <v-card v-if="isImageFile(form.eduFileUrl)" outlined
                                                                class="rounded-lg overflow-hidden"
                                                                style="border-color: #e0e0e0 !important;">
                                                                <a :href="form.eduFileUrl" target="_blank">
                                                                    <v-img :src="form.eduFileUrl" max-height="300"
                                                                        contain
                                                                        class="grey lighten-4 cursor-pointer"></v-img>
                                                                </a>
                                                                <div
                                                                    class="pa-2 text-center grey lighten-5 border-t text-caption">
                                                                    <a :href="form.eduFileUrl" target="_blank"
                                                                        class="teal--text text--darken-4 font-weight-bold text-decoration-none">
                                                                        <v-icon x-small color="teal darken-4"
                                                                            class="mr-1">mdi-open-in-new</v-icon> Click
                                                                        để xem ảnh
                                                                        phóng to
                                                                    </a>
                                                                </div>
                                                            </v-card>

                                                            <!-- If it is NOT an image: show file icon and download button -->
                                                            <v-card v-else outlined
                                                                class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                                style="background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                                <div class="d-flex align-center text-truncate mr-2">
                                                                    <v-icon color="teal darken-4"
                                                                        class="mr-2">mdi-file-document-outline</v-icon>
                                                                    <span
                                                                        class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">Tài
                                                                        liệu bằng cấp 1</span>
                                                                </div>
                                                                <v-btn color="teal darken-4" dark small
                                                                    class="rounded-lg font-weight-bold"
                                                                    :href="form.eduFileUrl" target="_blank">
                                                                    <v-icon small left>mdi-download</v-icon> Tải xuống
                                                                </v-btn>
                                                            </v-card>
                                                        </div>
                                                    </v-col>

                                                    <!-- Bằng cấp / Chứng chỉ 2 -->
                                                    <v-col cols="12" sm="6" class="mb-3">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Bằng cấp / Chứng chỉ 2</div>
                                                        <div v-if="!form.eduFile2Url"
                                                            class="text-caption red--text pl-2">
                                                            Không có file bằng cấp 2
                                                        </div>
                                                        <div v-else>
                                                            <!-- If it is an image: display exactly like CCCD -->
                                                            <v-card v-if="isImageFile(form.eduFile2Url)" outlined
                                                                class="rounded-lg overflow-hidden"
                                                                style="border-color: #e0e0e0 !important;">
                                                                <a :href="form.eduFile2Url" target="_blank">
                                                                    <v-img :src="form.eduFile2Url" max-height="300"
                                                                        contain
                                                                        class="grey lighten-4 cursor-pointer"></v-img>
                                                                </a>
                                                                <div
                                                                    class="pa-2 text-center grey lighten-5 border-t text-caption">
                                                                    <a :href="form.eduFile2Url" target="_blank"
                                                                        class="teal--text text--darken-4 font-weight-bold text-decoration-none">
                                                                        <v-icon x-small color="teal darken-4"
                                                                            class="mr-1">mdi-open-in-new</v-icon> Click
                                                                        để xem ảnh
                                                                        phóng to
                                                                    </a>
                                                                </div>
                                                            </v-card>

                                                            <!-- If it is NOT an image: show file icon and download button -->
                                                            <v-card v-else outlined
                                                                class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                                style="background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                                <div class="d-flex align-center text-truncate mr-2">
                                                                    <v-icon color="teal darken-4"
                                                                        class="mr-2">mdi-file-document-outline</v-icon>
                                                                    <span
                                                                        class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">Tài
                                                                        liệu bằng cấp 2</span>
                                                                </div>
                                                                <v-btn color="teal darken-4" dark small
                                                                    class="rounded-lg font-weight-bold"
                                                                    :href="form.eduFile2Url" target="_blank">
                                                                    <v-icon small left>mdi-download</v-icon> Tải xuống
                                                                </v-btn>
                                                            </v-card>
                                                        </div>
                                                    </v-col>

                                                    <!-- Chứng chỉ hành nghề dược -->
                                                    <v-col cols="12" sm="6" class="mb-3" v-if="form.pharmaCertUrl">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            Chứng chỉ hành nghề dược</div>
                                                        <v-card v-if="isImageFile(form.pharmaCertUrl)" outlined
                                                            class="rounded-lg overflow-hidden"
                                                            style="border-color: #e0e0e0 !important;">
                                                            <a :href="form.pharmaCertUrl" target="_blank">
                                                                <v-img :src="form.pharmaCertUrl" max-height="300"
                                                                    contain
                                                                    class="grey lighten-4 cursor-pointer"></v-img>
                                                            </a>
                                                            <div
                                                                class="pa-2 text-center grey lighten-5 border-t text-caption">
                                                                <a :href="form.pharmaCertUrl" target="_blank"
                                                                    class="teal--text text--darken-4 font-weight-bold text-decoration-none">
                                                                    <v-icon x-small color="teal darken-4"
                                                                        class="mr-1">mdi-open-in-new</v-icon> Click để xem ảnh
                                                                    phóng to
                                                                </a>
                                                            </div>
                                                        </v-card>
                                                        <v-card v-else outlined
                                                            class="pa-3 rounded-lg d-flex align-center justify-space-between"
                                                            style="background-color: #fafafa; border-color: #e0e0e0 !important;">
                                                            <div class="d-flex align-center text-truncate mr-2">
                                                                <v-icon color="teal darken-4"
                                                                    class="mr-2">mdi-file-document-outline</v-icon>
                                                                <span
                                                                    class="text-subtitle-2 font-weight-medium text-truncate grey--text text--darken-4 text-caption">Tài
                                                                    liệu chứng chỉ</span>
                                                            </div>
                                                            <v-btn color="teal darken-4" dark small
                                                                class="rounded-lg font-weight-bold"
                                                                :href="form.pharmaCertUrl" target="_blank">
                                                                <v-icon small left>mdi-download</v-icon> Tải xuống
                                                            </v-btn>
                                                        </v-card>
                                                    </v-col>

                                                    <!-- CMND/CCCD mặt trước -->
                                                    <v-col cols="12" sm="6" class="mb-3">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            CMND/CCCD mặt trước</div>
                                                        <div v-if="!form.idFrontImageUrl"
                                                            class="text-caption grey--text pl-2">
                                                            Chưa tải lên hình ảnh
                                                        </div>
                                                        <v-card v-else outlined class="rounded-lg overflow-hidden"
                                                            style="border-color: #e0e0e0 !important;">
                                                            <a :href="form.idFrontImageUrl" target="_blank">
                                                                <v-img :src="form.idFrontImageUrl" max-height="300"
                                                                    contain
                                                                    class="grey lighten-4 cursor-pointer"></v-img>
                                                            </a>
                                                            <div
                                                                class="pa-2 text-center grey lighten-5 border-t text-caption">
                                                                <a :href="form.idFrontImageUrl" target="_blank"
                                                                    class="teal--text text--darken-4 font-weight-bold text-decoration-none">
                                                                    <v-icon x-small color="teal darken-4"
                                                                        class="mr-1">mdi-open-in-new</v-icon> Click để
                                                                    xem ảnh
                                                                    phóng to
                                                                </a>
                                                            </div>
                                                        </v-card>
                                                    </v-col>

                                                    <!-- CMND/CCCD mặt sau -->
                                                    <v-col cols="12" sm="6" class="mb-3">
                                                        <div
                                                            class="font-weight-bold text-subtitle-2 mb-2 grey--text text--darken-3">
                                                            CMND/CCCD mặt sau</div>
                                                        <div v-if="!form.idBackImageUrl"
                                                            class="text-caption grey--text pl-2">
                                                            Chưa tải lên hình ảnh
                                                        </div>
                                                        <v-card v-else outlined class="rounded-lg overflow-hidden"
                                                            style="border-color: #e0e0e0 !important;">
                                                            <a :href="form.idBackImageUrl" target="_blank">
                                                                <v-img :src="form.idBackImageUrl" max-height="300"
                                                                    contain
                                                                    class="grey lighten-4 cursor-pointer"></v-img>
                                                            </a>
                                                            <div
                                                                class="pa-2 text-center grey lighten-5 border-t text-caption">
                                                                <a :href="form.idBackImageUrl" target="_blank"
                                                                    class="teal--text text--darken-4 font-weight-bold text-decoration-none">
                                                                    <v-icon x-small color="teal darken-4"
                                                                        class="mr-1">mdi-open-in-new</v-icon> Click để
                                                                    xem ảnh
                                                                    phóng to
                                                                </a>
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-tab-item>
                                        </v-tabs>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Right Appraisal Panel -->
                            <v-col cols="12" md="4">
                                <v-card outlined class="rounded-lg overflow-hidden elevation-1"
                                    style="background-color: #ffffff; border-color: #e0e0e0 !important;">
                                    <div class="px-4 py-3 d-flex align-center justify-space-between grey lighten-4"
                                        style="border-bottom: 1px solid #e0e0e0;">
                                        <div class="d-flex align-center">
                                            <v-icon color="teal darken-4" class="mr-2" small>mdi-draw-pen</v-icon>
                                            <span
                                                class="font-weight-bold text-subtitle-2 teal--text text--darken-4 uppercase-title">
                                                ĐÁNH GIÁ & TIẾN TRÌNH
                                            </span>
                                        </div>
                                        <v-chip x-small :color="getStatusBg(form.status)"
                                            :text-color="getStatusTextColor(form.status)"
                                            class="font-weight-bold text-uppercase px-2">
                                            {{ getStatusText(form.status) }}
                                        </v-chip>
                                    </div>
                                    <v-card-text class="pa-4">
                                        <!-- Section 1: Tiến Trình Tuyển Dụng -->
                                        <div class="d-flex align-center mb-3">
                                            <v-icon x-small color="teal" class="mr-1">mdi-circle-slice-8</v-icon>
                                            <span class="text-caption font-weight-bold grey--text text--darken-2">TIẾN
                                                TRÌNH TUYỂN DỤNG</span>
                                        </div>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-select outlined dense label="Trạng thái" v-model="form.status"
                                                    :items="statuses" hide-details="auto" class="mb-3"></v-select>
                                            </v-col>
                                            <v-col cols="12" v-show="form.status == 'FAIL'">
                                                <v-select outlined dense :items="failNotes" v-model="form.failNote"
                                                    label="Lý do hồ sơ loại" hide-details="auto"
                                                    class="mb-3"></v-select>
                                            </v-col>
                                            <v-col cols="12" v-show="form.status == 'BLACK'">
                                                <v-select outlined dense :items="notAcceptNotes"
                                                    v-model="form.notAcceptNote" clearable hide-details="auto"
                                                    label="Lý do không nhận việc" class="mb-3"></v-select>
                                            </v-col>
                                        </v-row>

                                        <v-divider class="my-3"></v-divider>

                                        <!-- Section 2: Lịch Hẹn Phỏng Vấn -->
                                        <div class="d-flex align-center mb-3">
                                            <v-icon x-small color="teal" class="mr-1">mdi-calendar-clock</v-icon>
                                            <span class="text-caption font-weight-bold grey--text text--darken-2">LỊCH
                                                HẸN PHỎNG VẤN</span>
                                        </div>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-text-field outlined dense type="datetime-local"
                                                    label="Thời gian phỏng vấn" v-model="form.interviewAt"
                                                    hide-details="auto" class="mb-3"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-select outlined dense label="Nền tảng"
                                                    v-model="form.interviewPlatform" :items="interviewPlatforms"
                                                    hide-details="auto" class="mb-3"></v-select>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field outlined dense label="Phòng / Link"
                                                    v-model="form.interviewPlace" hide-details="auto"
                                                    class="mb-3"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-divider class="my-3"></v-divider>

                                        <!-- Section 3: Đãi Ngộ & Đánh Giá -->
                                        <div class="d-flex align-center mb-3">
                                            <v-icon x-small color="teal" class="mr-1">mdi-cash-multiple</v-icon>
                                            <span class="text-caption font-weight-bold grey--text text--darken-2">ĐÃI
                                                NGỘ & ĐÁNH GIÁ</span>
                                        </div>
                                        <v-row dense>
                                            <v-col cols="6">
                                                <v-text-field outlined dense label="Lương mong đợi"
                                                    v-model="form.expectSalary" suffix="đ" hide-details="auto"
                                                    class="mb-1"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field outlined dense label="Lương thỏa thuận"
                                                    v-model="form.dealSalary" suffix="đ" hide-details="auto"
                                                    class="mb-1"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="text-caption grey--text text-right mb-2"
                                                v-if="form.expectSalary || form.dealSalary">
                                                <span v-if="form.expectSalary" class="mr-2">M.đợi: {{
                                                    currencyFormat(form.expectSalary) }}đ</span>
                                                <span v-if="form.dealSalary">T.thuận: {{ currencyFormat(form.dealSalary)
                                                }}đ</span>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-textarea outlined dense label="Nhận xét" v-model="form.comment"
                                                    hide-details="auto" rows="2" class="mb-3"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" class="text-center">
                                                <v-btn color="teal darken-4" dark block
                                                    class="font-weight-bold rounded-lg py-5" type="submit">
                                                    <v-icon left>mdi-content-save-outline</v-icon> Lưu dữ liệu
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DatePicker from '@/components/DatePicker';
import http from '@/components/services/http-common'
import ApiService from '@/components/services/ApiServices'
import moment from 'moment';

export default {
    components: {
        "date-picker": DatePicker,
    },
    props: ["value", "item"],
    watch: {
        dialog: {
            handler(val) {
                this.fetchJob()
                this.fetchCity()
                this.fetchEducationLevel()
                this.fetchEducationMajor()
                this.fetchUniversity()
                this.fetchOrigin()
                this.fetchEthnicity()
                this.fetchReligion()
                this.fetchNewCity()
                if (val) {
                    this.$nextTick(() => {
                        console.log("run")
                        document.getElementsByClassName('v-card__text')[0].scrollTop = 0
                    });
                    if (this.isEdit)
                        this.fetch().then(() => {
                            this.fetchJobDistrict1(this.form.city1Code, true)
                            this.fetchJobDistrict2(this.form.city2Code, true)

                            // old address (mapped to usual endpoints for old mapping logic)
                            this.fetchDistrict(this.form.oldCityCode, true)
                            this.fetchWard(this.form.oldDistrictCode, true)
                            this.fetchDDistrict(this.form.oldDCityCode, true)
                            this.fetchDWard(this.form.oldDDistrictCode, true)

                            // new address fetchs
                            this.fetchNewWard(this.form.newCityId, true)
                        });
                }
                else {
                    this.close();
                }
            }
        }
    },
    computed: {
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val) {
                return this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        }
    },
    data() {
        return {
            endpoint: process.env.VUE_APP_BASE_URL,
            ROOT_URL: "candidates",
            JOB_URL: "candidates/fetch-job",
            //DIALOG
            dialogDelete: false,
            targetItem: {},

            addressTab: null,

            pharmaCerts: [
                { text: "Không có", value: "KHONG" },
                { text: "CCHN Cao đẳng", value: "CD" },
                { text: "CCHN Đại học", value: "DH" },
            ],

            educationStatuses: [
                { text: "Đã tốt nghiệp", value: true },
                { text: "Chưa tốt nghiệp", value: false },
            ],

            failNotes: [
                "Không đến phỏng vấn",
                "Nhảy việc nhiều",
                "Không phù hợp văn hóa công ty",
                "Yêu cầu mức lương cao",
                "Địa điểm làm việc không phù hợp",
                "Độ tuổi không phù hợp",
                "Liên hệ nhiều lần không được",
                "Khác"
            ],
            notAcceptNotes: [
                "Đã tìm được công việc khác",
                "Địa điểm làm việc không phù hợp",
                "Công ty khác đãi ngộ tốt hơn",
                "Đang bận việc gia đình",
                "Khác",
            ],

            valid: true,
            expCompanies: [],

            form: {
                //tab1
                avatarUrl: '',
                name: '',
                phoneNumber: '',
                mail: '',
                gender: false,
                birthDay: new Date().toISOString().substr(0, 10),
                jobCode: null,
                cityCode: null,
                districtCode: null,
                wardCode: null,
                address: null,
                DCityCode: null,
                DDistrictCode: null,
                DWardCode: null,
                DAddress: null,

                oldCityCode: null,
                oldDistrictCode: null,
                oldWardCode: null,
                oldAddress: null,
                oldDCityCode: null,
                oldDDistrictCode: null,
                oldDWardCode: null,
                oldDAddress: null,

                newCityId: null,
                newWardId: null,
                newAddress: null,

                city1Code: null,
                city2Code: null,

                educationLevelCode: null,
                educationMajorCode: null,
                universityCode: null,
                graduateStatus: null,
                eduRating: null,
                educationLevel2Code: null,
                educationMajor2Code: null,
                university2Code: null,
                graduateStatus2: null,
                eduRating2: null,
                recruitChannel: null,
                yearExperience: null,
                interviewAt: moment().format("YYYY-MM-DDTHH:mm"),
                interviewPlatform: "tt",
                interviewPlace: "",

                attachmentFile: undefined,
                attachmentUrl: "",
                dealSalary: null,
                expectSalary: null,
                height: 1,
                weight: 40,

                failNote: "",
                notAcceptNote: "",
                pharmaCert: "",
                hasPharmaCert: null,
                pharmaCertUrl: "",
                idFrontImageUrl: "",
                idBackImageUrl: "",
                eduFileUrl: "",
                eduFile2Url: "",

                originCode: "",
                ethnicityCode: "",
                religionCode: "",
                jobDistrict1Code: "",
                jobDistrict2Code: "",
                taxNumber: "",
                insuranceNumber: "",

            },
            defaultForm: {
                //tab1
                avatarUrl: '',
                name: '',
                phoneNumber: '',
                mail: '',
                gender: false,
                birthDay: new Date().toISOString().substr(0, 10),
                jobCode: null,
                cityCode: null,
                districtCode: null,
                wardCode: null,
                address: null,
                DCityCode: null,
                DDistrictCode: null,
                DWardCode: null,
                DAddress: null,

                oldCityCode: null,
                oldDistrictCode: null,
                oldWardCode: null,
                oldAddress: null,
                oldDCityCode: null,
                oldDDistrictCode: null,
                oldDWardCode: null,
                oldDAddress: null,

                newCityId: null,
                newWardId: null,
                newAddress: null,

                city1Code: null,
                city2Code: null,

                educationLevelCode: null,
                educationMajorCode: null,
                universityCode: null,
                graduateStatus: null,
                eduRating: null,
                educationLevel2Code: null,
                educationMajor2Code: null,
                university2Code: null,
                graduateStatus2: null,
                eduRating2: null,
                recruitChannel: null,
                yearExperience: null,
                interviewAt: moment().format("YYYY-MM-DDTHH:mm"),
                interviewPlatform: "tt",
                interviewPlace: "",

                attachmentFile: undefined,
                attachmentUrl: "",
                dealSalary: null,
                expectSalary: null,
                height: 1,
                weight: 40,

                failNote: "",
                notAcceptNote: "",
                pharmaCert: "",
                hasPharmaCert: null,
                pharmaCertUrl: "",
                idFrontImageUrl: "",
                idBackImageUrl: "",

                originCode: "",
                ethnicityCode: "",
                religionCode: "",
                jobDistrict1Code: "",
                jobDistrict2Code: "",
                taxNumber: "",
                insuranceNumber: "",
                eduFileUrl: "",
                eduFile2Url: "",
            },

            cities: [],
            districts: [],
            wards: [],

            newCities: [],
            newWards: [],

            dCities: [],
            dDistricts: [],
            dWards: [],
            jobs: [],
            educationLevels: [],
            educationMajors: [],
            universities: [],
            origins: [],
            ethnicities: [],
            religions: [],
            jobDistrict1s: [],

            expCompanyHeaders: [
                { text: 'Tên', value: 'name' },
                { text: 'Vị trí', value: 'position' },
                { text: 'Từ', value: 'from' },
                { text: 'Đến', value: 'to' },
                { text: 'Ghi chú', value: 'quitNote', width: 250 },
                { text: 'Tham chiếu', value: 'reference' },
            ],

            statuses: [
                { text: "Mới", value: "NEW" },
                { text: "Phỏng vấn", value: "PEND" },
                { text: "Chờ xác nhận", value: "WAITCF" },
                { text: "Đạt", value: "PASS" },
                { text: "Loại", value: "FAIL" },
                { text: "Không phỏng vấn", value: "NMEET" },
                { text: "Không liên hệ", value: "BLACK" },
            ],
            recruitChannels: [
                { text: "Mạng xã hội", value: "MXH" },
                { text: "Tờ rơi", value: "TR" },
                { text: "Được giới thiệu", value: "N" },
                { text: "Trang tuyển dụng", value: "TTD" },
            ],
            interviewPlatforms: [
                { text: "Trực tiếp", value: "tt" },
                { text: "Online", value: "online" }
            ],
            yearExperiences: [
                { text: " Chưa có kinh nghiệm", value: 0 },
                { text: " 6 tháng", value: 0.5 },
                { text: " 1 năm", value: 1 },
                { text: " 2 năm", value: 2 },
                { text: " 3 năm", value: 3 },
            ],
        }
    },
    methods: {

        isImageFile(url) {
            if (!url) return false;
            const cleanUrl = url.split('?')[0].split('#')[0];
            const extension = cleanUrl.substring(cleanUrl.lastIndexOf('.') + 1).toLowerCase();
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension);
        },
        getStatusBg(status) {
            const colors = {
                "NEW": "blue lighten-5",
                "PEND": "orange lighten-5",
                "WAITCF": "purple lighten-5",
                "PASS": "green lighten-5",
                "FAIL": "red lighten-5",
                "NMEET": "grey lighten-4",
                "BLACK": "grey lighten-2"
            };
            return colors[status] || "grey lighten-4";
        },
        getStatusTextColor(status) {
            const colors = {
                "NEW": "blue darken-3",
                "PEND": "orange darken-4",
                "WAITCF": "purple darken-3",
                "PASS": "green darken-3",
                "FAIL": "red darken-3",
                "NMEET": "grey darken-3",
                "BLACK": "grey darken-4"
            };
            return colors[status] || "grey darken-3";
        },
        getStatusText(status) {
            const item = this.statuses.find(s => s.value === status);
            return item ? item.text : status || "Mới";
        },
        copyText(refName) {
            let textToCopy = this.$refs[refName].$el.querySelector('input')
            textToCopy.select()
            document.execCommand("copy");
        },
        formatPharmaCert(value) {
            const pharmaCerts = {
                "KHONG": "Không có",
                "CD": "CCHN Cao đẳng",
                "DH": "CCHN Đại học",
            }
            return pharmaCerts[value]
        },
        currencyFormat(x) {
            if (x != null)
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        createEmployee() {
            var candidate = "2"
            this.$router.replace({ name: 'Employee', params: { candidate } });
        },
        download() {
            return http.get(this.form.attachmentUrl,
                {
                    params: {
                        download: this.form.attachmentUrl
                    },
                    responseType: 'arraybuffer',
                })
                .then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = this.form.attachmentUrl;
                    link.setAttribute('download', 'hosoungvien_' + this.form.name + '.zip'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        close() {
            this.$emit("CloseDialog");
            this.expCompanies = []
            this.form = Object.assign({}, this.defaultForm);
        },

        save() {
            if (this.form.hasPharmaCert === true) {
                if (this.form.pharmaCert !== "CD" && this.form.pharmaCert !== "DH") {
                    this.form.pharmaCert = "CO";
                }
            } else if (this.form.hasPharmaCert === false) {
                this.form.pharmaCert = "KHONG";
            } else {
                this.form.pharmaCert = null;
            }
            return http.put(this.ROOT_URL + "/" + this.item.code, this.form).then(res => {
                this.dialog = false;
                this.$emit("fetch");
            });
        },

        // ********** Fetch data *************
        fetch() {
            return http.get(this.ROOT_URL + "/" + this.item.code)
                .then(res => {
                    let item = res.data.item
                    this.expCompanies = res.data.workHistory
                    this.form = Object.assign({}, item)
                    const isPharma = (item.hasPharmaCert === true || item.hasPharmaCert === 1 || item.hasPharmaCert === 'true' || item.pharmaCert === true || item.pharmaCert === 1 || item.pharmaCert === 'CO' || item.pharmaCert === 'CD' || item.pharmaCert === 'DH');
                    const isNotPharma = (item.hasPharmaCert === false || item.hasPharmaCert === 0 || item.hasPharmaCert === 'false' || item.pharmaCert === false || item.pharmaCert === 0 || item.pharmaCert === 'KHONG');
                    this.form.hasPharmaCert = isPharma ? true : (isNotPharma ? false : null);
                    if (this.form.graduateStatus !== null && this.form.graduateStatus !== undefined) {
                        this.form.graduateStatus = (this.form.graduateStatus === true || this.form.graduateStatus === 1 || this.form.graduateStatus === '1' || this.form.graduateStatus === 'true' || this.form.graduateStatus === 'CO');
                    }
                    if (this.form.graduateStatus2 !== null && this.form.graduateStatus2 !== undefined) {
                        this.form.graduateStatus2 = (this.form.graduateStatus2 === true || this.form.graduateStatus2 === 1 || this.form.graduateStatus2 === '1' || this.form.graduateStatus2 === 'true' || this.form.graduateStatus2 === 'CO');
                    }
                    if (!this.form.interviewPlatform) {
                        this.form.interviewPlatform = "tt";
                    }
                    this.form.birthDay = moment(this.form.birthDay, "DD/MM/YYYY").format("YYYY-MM-DD")
                    this.form.idDate = moment(this.form.idDate, "YYYY-MM-DD").format("YYYY-MM-DD")
                    if (this.form.interviewAt) {
                        this.form.interviewAt = moment(this.form.interviewAt).format("YYYY-MM-DDTHH:mm")
                    }
                    // this.form.idDate = moment(this.form.idDate, "YYYY-MM-DD").format("YYYY-MM-DD")
                    // this.form.iDdate = this.form.iDdateString
                })
                .catch(err => {
                    console.log(err);
                });
        },

        fetchJob() {
            return http.get(this.JOB_URL)
                .then(res => {
                    this.jobs = res.data.items;
                }).catch(err => { throw err });
        },
        fetchCity() {
            return http.get("cities", {
                params: { dropDown: 1 }
            }).then(res => {
                this.cities = res.data.items;
            }).catch(err => {
                console.log(err);
            });
        },
        fetchNewCity() {
            return http.get("addresses/cities").then(res => {
                this.newCities = res.data.items || res.data.data;
            }).catch(err => {
                console.log(err);
            });
        },
        fetchDistrict(val, init = false) {
            if (val) {
                if (!init) {
                    this.districts = [];
                    this.form.districtCode = null;
                }
                return http.get("cities/fetch-district/" + val).then(res => {
                    this.districts = res.data;
                }).catch(err => {
                    console.log(err);
                });
            }
        },
        fetchJobDistrict1(val, init = false) {
            if (val) {
                if (!init) {
                    this.jobDistrict1s = [];
                    this.form.jobDistrict1Code = null;
                }
                return http.get("cities/fetch-district/" + val).then(res => {
                    this.jobDistrict1s = res.data;
                }).catch(err => {
                    console.log(err);
                });
            }
        },
        fetchJobDistrict2(val, init = false) {
            if (val) {
                if (!init) {
                    this.jobDistrict2s = [];
                    this.form.jobDistrict2Code = null;
                }
                return http.get("cities/fetch-district/" + val).then(res => {
                    this.jobDistrict2s = res.data;
                }).catch(err => {
                    console.log(err);
                });
            }
        },

        fetchWard(val, init = false) {
            if (val) {
                if (!init) {
                    this.wards = [];
                    this.form.oldWardCode = null;
                }
                return http.get("districts/fetch-ward/" + val).then(res => {
                    this.wards = res.data;
                });
            }
        },

        fetchNewWard(val, init = false) {
            if (val) {
                if (!init) {
                    this.newWards = [];
                    this.form.newWardId = null;
                }
                return http.get("addresses/wards", { params: { cityId: val } }).then(res => {
                    this.newWards = res.data.items || res.data.data;
                });
            }
        },

        fetchDDistrict(val, init = false) {
            if (val) {
                if (!init) {
                    this.dDistricts = [];
                    this.form.dDistrictCode = null;
                }
                return http.get("cities/fetch-district/" + val).then(res => {
                    this.dDistricts = res.data;
                }).catch(err => {
                    console.log(err);
                });
            }
        },

        fetchDWard(val, init = false) {
            if (val) {
                if (!init) {
                    this.dWards = [];
                    this.form.oldDWardCode = null;
                }
                return http.get("districts/fetch-ward/" + val).then(res => {
                    this.dWards = res.data;
                });
            }
        },

        fetchEducationLevel() {
            ApiService.fetchEducationLevel().then(res => {
                this.educationLevels = res.data;
            })
        },
        fetchEducationMajor() {
            ApiService.fetchEducationMajor().then(res => {
                this.educationMajors = res.data;
            })
        },
        fetchUniversity() {
            ApiService.fetchUniversity().then(res => {
                this.universities = res.data;
            })
        },

        fetchOrigin() {
            return ApiService.fetchOrigin().then(res => {
                this.origins = res.data;
            })
        },
        fetchEthnicity() {
            return ApiService.fetchEthnicity().then(res => {
                this.ethnicities = res.data;
            })
        },
        fetchReligion() {
            return ApiService.fetchReligion().then(res => {
                this.religions = res.data;
            })
        },

        // fetchEducation () {
        //     http.get("educationlevels").then(res => {
        //         this.formData.EducationLevels = res.data.items.map(function(obj) {
        //         return {
        //             text: obj.name,
        //             value: obj.code,
        //             }
        //         });
        //     }).catch(err => {
        //         console.log(err)
        //     });
        //     http.get("universities").then(res => {
        //         this.Universities = res.data.items.map(function(obj) {
        //         return {
        //             text: obj.name,
        //             value: obj.code,
        //             }
        //         });
        //     }).catch(err => {
        //         console.log(err)
        //     });
        //     http.get("academicranks").then(res => {
        //         this.formData.AcademicRanks = res.data.items.map(function(obj) {
        //         return {
        //             text: obj.name,
        //             value: obj.code,
        //             }
        //         });
        //     }).catch(err => {
        //         console.log(err)
        //     });
        //     http.get("educationmajors").then(res => {
        //         this.formData.EducationMajors = res.data.items.map(function(obj) {
        //         return {
        //             text: obj.name,
        //             value: obj.code,
        //             }
        //         });
        //     }).catch(err => {
        //         console.log(err)
        //     });
        // },
    },
    created() {
    }

}
</script>
<style scoped>
::v-deep .v-input label.v-label.v-label--active.theme--light {
    font-weight: bold !important;
}

.uppercase-title {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.85rem !important;
}

.border-teal-light {
    border: 1px solid #B2DFDB !important;
}

.border {
    border: 1px solid #e0e0e0;
}

.cursor-pointer {
    cursor: pointer;
}

::v-deep .scrollable-tab-items .v-tabs-items {
    max-height: 380px;
    overflow-y: auto;
}

::v-deep .scrollable-tab-items .v-tabs-items::-webkit-scrollbar {
    width: 6px;
}

::v-deep .scrollable-tab-items .v-tabs-items::-webkit-scrollbar-track {
    background: #fafafa;
    border-radius: 4px;
}

::v-deep .scrollable-tab-items .v-tabs-items::-webkit-scrollbar-thumb {
    background: #cfd8dc;
    border-radius: 4px;
}

::v-deep .scrollable-tab-items .v-tabs-items::-webkit-scrollbar-thumb:hover {
    background: #b0bec5;
}

/* Hide outer dialog body scrollbar */
::v-deep .v-card__text::-webkit-scrollbar {
    display: none !important;
}

::v-deep .v-card__text {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
}
</style>